<template>
  <div class="pc-note__catalog-item">
    <div class="header" :class="{active: isNoteActive}" :style="{'padding-left':paddingLeft}" @contextmenu="contextmenuHandler" @click="goHandler">
      <div v-if="isEmpty" class="arrow"></div>
      <div v-else class="arrow" @click.stop="onToggleFolded"><i :class="{'el-icon-arrow-down':!folded, 'el-icon-arrow-right':folded}"/></div>
      <icon-book v-if="data.root" class="static type-icon"/>
      <icon-file-alt v-else-if="data.type === 'NOTE'" class="static type-icon"/>
      <icon-folder v-else-if="data.type='CATALOG'" class="static type-icon"/>
      <div class="name">{{data.name}}</div>
    </div>
    <div class="items" v-if="!isEmpty" v-show="!folded">
      <catalog-item v-for="(item) in data.items" :key="item.id" :data="item" :paths="childrenPaths(data.name)"/>
    </div>
  </div>
</template>

<script>
import { mapMutations } from 'vuex'
import IconBook from '@/components/icon/Book.vue'
import IconFileAlt from '@/components/icon/FileAlt.vue'
import IconFolder from '@/components/icon/Folder.vue'
import { createPopper } from '@popperjs/core'

export default {
  name: 'CatalogItem',
  components: {
    IconBook,
    IconFileAlt,
    IconFolder
  },
  props: {
    data: {
      type: Object,
      required: true
    },
    paths: {
      type: Array,
      default: () => []
    }
  },
  data () {
    return {
      folded: false
    }
  },
  computed: {
    paddingLeft () {
      return `${this.paths.length * 1.6 + 1}rem`
    },
    isEmpty () {
      return !(this.data.items && this.data.items.length > 0)
    },
    childrenPaths () {
      return (name) => {
        const paths = [...this.paths]
        paths.push(name)
        return paths
      }
    },
    isNoteActive () {
      return this.data.type === 'NOTE' && this.$route.params.noteId === this.data.id
    }
  },
  methods: {
    ...mapMutations('contextmenu', {
      setVisible: 'SET_VISIBLE',
      setType: 'SET_TYPE',
      setData: 'SET_DATA'
    }),
    onToggleFolded () {
      this.folded = !this.folded
    },
    contextmenuHandler (event) {
      const x = event.clientX
      const y = event.clientY
      const virtualElement = {
        getBoundingClientRect: () => ({
          width: 0,
          height: 0,
          top: y,
          right: x,
          bottom: y,
          left: x
        })
      }

      if (this.data.root) {
        this.setType('WORKBENCH_SIDEBAR_CATALOG_NOTEBOOK')
        this.setData({
          type: 'NOTEBOOK'
        })
      } else if (this.data.type === 'CATALOG') {
        this.setType('WORKBENCH_SIDEBAR_CATALOG_NOTEBOOK_CATALOG')
        this.setData({
          type: 'NOTEBOOK_CATALOG',
          id: this.data.id,
          parentId: this.data.parentId
        })
      } else if (this.data.type === 'NOTE') {
        this.setType('WORKBENCH_SIDEBAR_CATALOG_NOTEBOOK_NOTE')
        this.setData({
          type: 'NOTEBOOK_NOTE',
          id: this.data.id,
          parentId: this.data.parentId
        })
      }

      this.setVisible(true)
      this.$nextTick(() => {
        window.contextmenuPopper = createPopper(virtualElement, window.document.getElementById('pc-contextmenu'), {
          placement: 'bottom-start',
          strategy: 'fixed'
        })
      })
    },
    goHandler () {
      if (this.data.type === 'NOTE') {
        const notCurrent = this.$route.params.noteId !== this.data.id
        if (notCurrent) {
          this.$router.push({
            name: 'workbenchNotebookNote',
            params: {
              noteId: this.data.id
            }
          })
        }
      }
    }
  }
}
</script>

<style lang="scss">
@import '@/assets/variables.scss';

.pc-note__catalog-item {
  user-select: none;
  .header {
    display: flex;
    padding: .5rem 1rem;
    cursor: pointer;

    &:hover {
      background: rgb(236, 245, 255);
    }

    &.active {
      background: rgb(236, 245, 255);
      color: $color-special;
    }
  }

  .type-icon {
    margin-right: .4rem;
    height: 1.6rem;
  }

  .arrow {
    display: flex;
    align-items: center;
    width: 1.6rem;
    height: 1.6rem;
  }

  .name {
    width: 0;
    flex-grow: 1;
    line-height: 1.6rem;
    word-break: break-all;
  }
}
</style>
